import { render, staticRenderFns } from "./BillingDetails.vue?vue&type=template&id=61fdad85&scoped=true"
import script from "./BillingDetails.vue?vue&type=script&lang=js"
export * from "./BillingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fdad85",
  null
  
)

export default component.exports